// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: "AIzaSyBK_XyRri4cOVBspmVJyyPhTLbsYF1wUfY",
    authDomain: "horses-birthday-rides.firebaseapp.com",
    projectId: "horses-birthday-rides",
    storageBucket: "horses-birthday-rides.appspot.com",
    messagingSenderId: "200989213047",
    appId: "1:200989213047:web:d0e49383b6d67528e82172",
    measurementId: "G-4L94YWNNHB"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);

export const db = getFirestore(app)